import React from "react";
import BannerList from "../../../components/AdminComponents/Banners";

const Home = () => {
  return (
    <div className="flex h-full ">
      <BannerList />
    </div>
  );
};

export default Home;
